export default {
  id: 'pricelist',
  title: 'Cjenik',
  icon: 'mdi-currency-eur',
  show: true,
  order: 8,
  children: [
    {
      id: 'pricelist-overview',
      title: 'Što je cjenik?',
      icon: 'mdi-information',
      show: true,
      order: 1,
      content: () => `
        <h2 id="what-is-pricelist">Što je cjenik?</h2>
        <p>
          Cjenik je lista cijena artikala koja definira koliko košta svaki proizvod ili usluga.
          U AI Kasa sustavu, cjenici omogućavaju fleksibilno određivanje cijena po prodajnom mjestu,
          valuti ili periodu (sezona, akcije).
        </p>

        <h3 class="mt-4">Zašto koristiti cjenike?</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Funkcionalnost</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Različite cijene po lokaciji</strong></td>
              <td>Svako prodajno mjesto može imati vlastiti cjenik</td>
            </tr>
            <tr>
              <td><strong>Sezonske cijene</strong></td>
              <td>Definirajte cijene za ljetnu i zimsku sezonu</td>
            </tr>
            <tr>
              <td><strong>Akcijske cijene</strong></td>
              <td>Privremeno sniženje cijena za određeni period</td>
            </tr>
            <tr>
              <td><strong>Više valuta</strong></td>
              <td>Definirajte cijene u EUR-ima, USD-ima ili drugim valutama</td>
            </tr>
            <tr>
              <td><strong>Veleprodajne cijene</strong></td>
              <td>Posebni cjenici za veleprodaju ili VIP kupce</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Tipovi cjenika</h3>

        <h4 class="mt-3">1. Osnovni cjenik</h4>
        <p>
          Glavni cjenik koji se koristi po defaultu za sve prodaje.
          Svaki artikl mora imati definiranu cijenu u osnovnom cjeniku.
        </p>

        <h4 class="mt-3">2. Cjenik po prodajnom mjestu</h4>
        <p>
          Definirajte različite cijene za različite lokacije:
        </p>
        <ul>
          <li><strong>Centar grada</strong> - Više cijene zbog veće potražnje</li>
          <li><strong>Periferija</strong> - Niže cijene za konkurentnost</li>
          <li><strong>Zračna luka</strong> - Premium cijene</li>
        </ul>

        <h4 class="mt-3">3. Sezonski cjenik</h4>
        <p>
          Različite cijene ovisno o sezoni:
        </p>
        <ul>
          <li><strong>Ljetni cjenik</strong> - Više cijene za turističku sezonu</li>
          <li><strong>Zimski cjenik</strong> - Standardne cijene izvan sezone</li>
        </ul>

        <h4 class="mt-3">4. Akcijski cjenik</h4>
        <p>
          Privremeno snižene cijene:
        </p>
        <ul>
          <li>Happy hour cijene (npr. 17:00-19:00)</li>
          <li>Black Friday akcija</li>
          <li>Rasprodaje i posebne ponude</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Prioritet cjenika:</strong> Ako artikl ima više cijena u različitim cjenicima,
            sustav koristi cjenik s najvišim prioritetom. Akcijski cjenici obično imaju najviši prioritet.
          </div>
        </div>

        <h3 class="mt-4">Struktura cjenika</h3>

        <p>Svaki cjenik sadrži:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Opis</th>
              <th>Primjer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Naziv</strong></td>
              <td>Jedinstveni naziv cjenika</td>
              <td>"Cjenik Split Centar"</td>
            </tr>
            <tr>
              <td><strong>Tip</strong></td>
              <td>Osnovni, Sezonski, Akcijski</td>
              <td>Sezonski</td>
            </tr>
            <tr>
              <td><strong>Prodajno mjesto</strong></td>
              <td>Za koje POS vrijedi</td>
              <td>Split Centar</td>
            </tr>
            <tr>
              <td><strong>Valuta</strong></td>
              <td>Valuta cijena</td>
              <td>EUR</td>
            </tr>
            <tr>
              <td><strong>Period važenja</strong></td>
              <td>Od - Do datum</td>
              <td>01.06.2024 - 30.09.2024</td>
            </tr>
            <tr>
              <td><strong>Prioritet</strong></td>
              <td>Redoslijed primjene</td>
              <td>1 (najviši)</td>
            </tr>
            <tr>
              <td><strong>Status</strong></td>
              <td>Aktivan / Neaktivan</td>
              <td>Aktivan</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Primjer korištenja</h3>

        <h4 class="mt-3">Scenarij: Restoran s dvije lokacije</h4>

        <p><strong>Lokacija 1: Restoran Centar</strong></p>
        <ul>
          <li>Kava espresso: 1.50 EUR</li>
          <li>Cappuccino: 2.00 EUR</li>
          <li>Cola 0.33L: 2.50 EUR</li>
        </ul>

        <p><strong>Lokacija 2: Restoran Plaža (sezonski cjenik)</strong></p>
        <ul>
          <li>Kava espresso: 2.00 EUR</li>
          <li>Cappuccino: 2.50 EUR</li>
          <li>Cola 0.33L: 3.00 EUR</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Kreirajte osnovni cjenik prvo, pa onda dodajte specifične cjenike
            prema potrebi. Tako ćete uvijek imati sigurnu cijenu za svaki artikl.
          </div>
        </div>

        <h3 class="mt-4">Upravljanje cjenicima</h3>

        <h4 class="mt-3">Pristup cjenicima</h4>
        <ol>
          <li>Idite na <strong>"Artikli" → "Cjenici"</strong></li>
          <li>Prikazat će se lista svih cjenika</li>
          <li>Možete dodavati, uređivati i brisati cjenike</li>
        </ol>

        <h4 class="mt-3">Dodavanje nove cijene</h4>
        <ol>
          <li>Odaberite cjenik</li>
          <li>Kliknite <strong>"+ Dodaj cijenu"</strong></li>
          <li>Odaberite artikl</li>
          <li>Unesite cijenu</li>
          <li>Spremite</li>
        </ol>

        <h4 class="mt-3">Masovna promjena cijena</h4>
        <p>Možete promijeniti cijene za više artikala odjednom:</p>
        <ul>
          <li><strong>Po postotku</strong> - Povećajte sve cijene za 10%</li>
          <li><strong>Po kategoriji</strong> - Promjena cijena samo za određenu kategoriju</li>
          <li><strong>Import iz Excel-a</strong> - Učitajte nove cijene iz datoteke</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Promjena cijena u cjeniku odmah se primjenjuje na blagajni.
            Provjerite cijene prije nego što ih aktivirate u prodaji.
          </div>
        </div>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Koliko cjenika mogu imati?</h4>
        <p>
          Možete imati neograničen broj cjenika. Svako prodajno mjesto može imati
          više cjenika koji se primjenjuju ovisno o periodu, valuti ili prioritetu.
        </p>

        <h4 class="mt-3">Što ako artikl nema cijenu u cjeniku?</h4>
        <p>
          Sustav će koristiti cijenu iz osnovnog cjenika. Ako ni tamo nema cijene,
          prikazat će se upozorenje prilikom pokušaja prodaje.
        </p>

        <h4 class="mt-3">Mogu li imati različite cijene za gotovinu i kartice?</h4>
        <p>
          Da, možete kreirati zasebne cjenike za različite načine plaćanja
          i postaviti prioritete prema vrsti plaćanja.
        </p>

        <h4 class="mt-3">Kako aktivirati akcijski cjenik?</h4>
        <p>
          Kreirajte akcijski cjenik, postavite period važenja i označite ga kao aktivan.
          Sustav će automatski koristiti taj cjenik u definiranom periodu.
        </p>
      `
    },
    {
      id: 'pricelist-add',
      title: 'Dodavanje artikla na cjenik',
      icon: 'mdi-plus',
      show: true,
      order: 2,
      content: () => `
        <h2 id="what-is">Što je dodavanje artikla na cjenik?</h2>
        <p>Cjenik je lista artikala s definiranim cijenama za specifično prodajno mjesto. Dodavanjem artikla na cjenik omogućujete njegovo prodavanje na blagajni. Jedan artikl može imati različite cijene na različitim prodajnim mjestima.</p>

        <h2 id="when-to-use" class="mt-6">Kada koristiti?</h2>
        <ul>
          <li>Nakon kreiranja novog artikla</li>
          <li>Kada želite omogućiti prodaju artikla na određenoj lokaciji</li>
          <li>Pri postavljanju različitih cijena za različita prodajna mjesta</li>
          <li>Kada ažurirate cijene postojećih artikala</li>
        </ul>

        <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
        <ul>
          <li>Pristup modulu "Artikli i cjenik" → "Cjenik"</li>
          <li>Artikl mora biti prethodno kreiran u "Artikli" modulu</li>
          <li>Znanje o pravilnoj cijeni artikla (sa ili bez PDV-a)</li>
        </ul>

        <h2 id="important-concept" class="mt-6">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 24px;"></i>
          Važno za razumijevanje
        </h2>
        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Artikl vs. Cjenik - Koja je razlika?</strong>
            <ul style="margin: 12px 0 12px 20px;">
              <li><strong>Artikl</strong> = Osnovni podaci (naziv, tip, kategorija, PDV, barcode)</li>
              <li><strong>Cjenik</strong> = Cijena artikla za specifičnu lokaciju</li>
            </ul>
            <strong>Primjer:</strong> Artikl "Cappuccino" može imati cijenu 8 kn u centru grada, a 6 kn na periferiji.
          </div>
        </div>

        <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

        <h3 class="mt-4">1. Otvaranje cjenika</h3>
        <ol>
          <li>Idite na <strong>"Artikli i cjenik" → "Cjenik"</strong></li>
          <li>Provjerite da je odabrana ispravna <strong>lokacija/prodajno mjesto</strong> (ako imate više)</li>
          <li>Vidjet ćete listu svih artikala koji su trenutno na cjeniku</li>
        </ol>

        <h3 class="mt-4">2. Dodavanje novog artikla</h3>
        <p>Postoje 2 načina dodavanja:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Način</th>
              <th>Kada koristiti</th>
              <th>Koraci</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Pojedinačno dodavanje</strong></td>
              <td>Za 1-5 artikala</td>
              <td>Kliknite gumb <strong>"+ Dodaj artikl"</strong></td>
            </tr>
            <tr>
              <td><strong>Grupno dodavanje</strong></td>
              <td>Za više od 5 artikala</td>
              <td>Kliknite <strong>"Grupno dodavanje"</strong> ili <strong>"Dodaj više"</strong></td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">3. Odabir artikla (pojedinačno dodavanje)</h3>
        <ol>
          <li>U dijalogu, kliknite na padajući izbornik ili polje za pretragu</li>
          <li>Pretraživanje možete izvršiti prema:
            <ul>
              <li><strong>Naziv</strong> - upišite dio naziva (npr. "coca")</li>
              <li><strong>Šifra</strong> - ako znate internu šifru (npr. "ART-001")</li>
              <li><strong>Kategorija</strong> - filtrirajte po kategoriji</li>
              <li><strong>Barcode</strong> - skenirajte ili upišite barcode</li>
            </ul>
          </li>
          <li>Odaberite artikl iz liste</li>
        </ol>

        <h3 class="mt-4">4. Postavljanje cijene</h3>
        <p>Unesite cijenu artikla. <strong>Važno:</strong> Ovisno o postavkama kompanije, cijena može biti:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Što unijeti</th>
              <th>Primjer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Cijene sadrže PDV</strong><br>(uključen PDV)</td>
              <td>Prodajna cijena sa PDV-om</td>
              <td>Artikl košta <strong>25,00 kn</strong> → Unesite <strong>25,00</strong></td>
            </tr>
            <tr>
              <td><strong>Cijene ne sadrže PDV</strong><br>(isključen PDV)</td>
              <td>Nabavna cijena bez PDV-a</td>
              <td>Artikl košta 25 kn s PDV-om → Unesite <strong>20,00</strong> (PDV se dodaje automatski)</td>
            </tr>
          </tbody>
        </table>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Kako provjeriti postavku?</strong>
            <br><br>
            Idite na <strong>"Postavke" → "Općenito"</strong> i potražite opciju <strong>"Cijene sadrže PDV"</strong>. Ako je označena ✓, unosite cijene s PDV-om.
          </div>
        </div>

        <h3 class="mt-4">5. Dodatne opcije (opcionalno)</h3>
        <p>Ovisno o sustavu, možete postaviti:</p>
        <ul>
          <li><strong>Cijena po valuti</strong> - Različite cijene za EUR, USD, itd.</li>
          <li><strong>Akcijska cijena</strong> - Privremena snižena cijena</li>
          <li><strong>Količinski popust</strong> - Niža cijena pri kupnji veće količine</li>
          <li><strong>Status</strong> - Aktivan/Neaktivan na cjeniku</li>
        </ul>

        <h3 class="mt-4">6. Spremanje</h3>
        <ol>
          <li>Provjerite je li cijena ispravna</li>
          <li>Kliknite <strong>"Spremi"</strong> ili <strong>"Dodaj"</strong></li>
          <li>Artikl je sada dostupan na blagajni</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Nakon dodavanja, testirajte na blagajni da provjerite je li artikl vidljiv i je li cijena ispravna.
          </div>
        </div>

        <h2 id="bulk-adding" class="mt-6">Grupno dodavanje artikala</h2>
        <p>Ako trebate dodati veći broj artikala odjednom:</p>
        <ol>
          <li>Kliknite <strong>"Grupno dodavanje"</strong> ili <strong>"Dodaj više"</strong></li>
          <li>Sustav prikazuje listu svih artikala koji NISU na cjeniku</li>
          <li>Označite checkboxom artikle koje želite dodati</li>
          <li>Za svaki artikl unesite cijenu</li>
          <li>Možete koristiti opciju <strong>"Kopiraj cijenu"</strong> za iste cijene</li>
          <li>Kliknite <strong>"Dodaj označene"</strong></li>
        </ol>

        <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
        <ul>
          <li><strong>Brzi unos:</strong> Koristite barcode scanner za brzi odabir artikala</li>
          <li><strong>Zaokruživanje:</strong> Koristite "okrugle" cijene za lakše upravljanje gotovinom (npr. 5,00 umjesto 4,99)</li>
          <li><strong>Kopiranje cijena:</strong> Ako postavljate više prodajnih mjesta, kopirajte cjenik između lokacija</li>
          <li><strong>Praćenje promjena:</strong> Sustav pamti povijest promjena cijena</li>
          <li><strong>Aktivan/Neaktivan:</strong> Umjesto brisanja, označite artikl kao neaktivan da ga sakrijete sa blagajne</li>
        </ul>

        <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

        <details>
          <summary>Ne vidim artikl koji želim dodati na cjenik?</summary>
          <p>Artikl mora prvo postojati u bazi artikala:</p>
          <ol>
            <li>Idite na "Artikli i cjenik" → "Artikli"</li>
            <li>Provjerite postoji li artikl u listi</li>
            <li>Ako ne postoji, prvo ga kreirajte pomoću <strong>"+ Dodaj artikl"</strong></li>
            <li>Zatim se vratite na "Cjenik" i dodajte ga</li>
          </ol>
        </details>

        <details>
          <summary>Artikl je već na cjeniku, mogu li promijeniti cijenu?</summary>
          <p>Da! Za promjenu cijene postojećeg artikla:</p>
          <ol>
            <li>U "Cjenik" modulu pronađite artikl</li>
            <li>Kliknite ikonu olovke <i class="mdi mdi-pencil" style="color: #3989C9; margin: 0 4px; font-size: 16px;"></i> ili dvostruki klik na redak</li>
            <li>Unesite novu cijenu</li>
            <li>Spremite</li>
            <li>Nova cijena je odmah aktivna na blagajni</li>
          </ol>
        </details>

        <details>
          <summary>Dodao sam artikl na cjenik, ali ga ne vidim na blagajni?</summary>
          <p>Provjere:</p>
          <ul>
            <li><strong>Lokacija:</strong> Provjerite jeste li dodali artikl na cjenik ispravne lokacije</li>
            <li><strong>Status:</strong> Provjerite je li artikl označen kao <span class="status-chip success">Aktivan</span></li>
            <li><strong>Osvježavanje:</strong> Ponekad treba osvježiti blagajnu (F5 ili logout/login)</li>
            <li><strong>Kategorija:</strong> Provjerite je li kategorija vidljiva na blagajni</li>
          </ul>
        </details>

        <details>
          <summary>Kako postaviti različite cijene za različite lokacije?</summary>
          <p>Svaka lokacija ima zasebni cjenik:</p>
          <ol>
            <li>U "Cjenik" modulu, odaberite <strong>prvu lokaciju</strong> iz padajućeg izbornika</li>
            <li>Dodajte artikl s cijenom za tu lokaciju</li>
            <li>Prebacite se na <strong>drugu lokaciju</strong></li>
            <li>Dodajte isti artikl s drugom cijenom</li>
          </ol>
          <p><strong>Primjer:</strong> "Cappuccino" može biti 8 kn u centru, a 6 kn na periferiji.</p>
        </details>

        <details>
          <summary>Treba li unositi cijenu s PDV-om ili bez PDV-a?</summary>
          <p>Ovisi o postavkama kompanije. Provjera:</p>
          <ol>
            <li>Idite na <strong>"Postavke" → "Općenito"</strong></li>
            <li>Pronađite opciju <strong>"Cijene sadrže PDV"</strong></li>
            <li>Ako je <strong>označena ✓</strong>: Unosite cijenu <strong>S PDV-om</strong> (prodajna cijena)</li>
            <li>Ako <strong>NIJE označena</strong>: Unosite cijenu <strong>BEZ PDV-a</strong> (sustav će automatski dodati PDV)</li>
          </ol>
        </details>

        <details>
          <summary>Mogu li obrisati artikl s cjenika?</summary>
          <p>Da, ali s ograničenjima:</p>
          <ul>
            <li>Možete obrisati artikl s cjenika ako nema aktivnih narudžbi</li>
            <li>Artikl će i dalje postojati u "Artikli" modulu</li>
            <li>Povijest prodaje ostaje sačuvana</li>
            <li><strong>Preporuka:</strong> Umjesto brisanja, označite artikl kao <span class="status-chip grey">Neaktivan</span> na cjeniku</li>
          </ul>
        </details>

        <details>
          <summary>Kako postaviti akcijsku cijenu?</summary>
          <p>Ako sustav podržava akcijske cijene:</p>
          <ol>
            <li>Pronađite artikl na cjeniku</li>
            <li>Kliknite na uređivanje</li>
            <li>Pronađite polje <strong>"Akcijska cijena"</strong> ili <strong>"Promo cijena"</strong></li>
            <li>Unesite sniženu cijenu i trajanje akcije</li>
            <li>Spremite</li>
          </ol>
          <p>Akcijska cijena se automatski primjenjuje na blagajni tijekom definiranog razdoblja.</p>
        </details>

        <details>
          <summary>Što su "Cijene po valuti"?</summary>
          <p>Ako poslujete s više valuta (EUR, USD, GBP, itd.):</p>
          <ul>
            <li>Možete definirati različite cijene za svaku valutu</li>
            <li>Na blagajni odaberete aktivnu valutu</li>
            <li>Sustav automatski koristi ispravnu cijenu</li>
            <li>Fiskalizacija se vrši u matičnoj valuti (EUR za RH)</li>
          </ul>
          <p><strong>Primjer:</strong> Artikl može koštati 10 EUR ili 11 USD ovisno o odabranoj valuti plaćanja.</p>
        </details>
      `
    },
    {
      id: 'pricelist-currencies',
      title: 'Različite cijene po valuti',
      icon: 'mdi-cash-multiple',
      show: true,
      order: 3,
      content: () => `
        <h2 id="currencies">Različite cijene po valuti</h2>
        <p>
          AI Kasa podržava više valuta, što omogućava postavljanje različitih cijena
          za isti artikl u različitim valutama (npr. EUR, USD, GBP).
        </p>

        <h3 class="mt-4">Dodavanje valute</h3>
        <ol>
          <li>Idite na <strong>"Postavke" → "Firma" → "Valute"</strong></li>
          <li>Kliknite <strong>"+ Dodaj valutu"</strong></li>
          <li>Odaberite valutu iz liste (EUR, USD, GBP, CHF, HRK, itd.)</li>
          <li>Postavite <strong>tečaj prema primarnoj valuti</strong></li>
          <li>Kliknite <strong>"Spremi"</strong></li>
        </ol>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Primarna valuta:</strong> Prva valuta koju postavite postaje primarna valuta firme. Sve cijene se izračunavaju u odnosu na nju.
          </div>
        </div>

        <h3 class="mt-4">Postavljanje cijene u različitim valutama</h3>
        <p>Nakon što ste dodali valute, možete postaviti cijene za artikle:</p>
        <ol>
          <li>Idite na <strong>"Cjenik"</strong></li>
          <li>Odaberite artikl ili kliknite <strong>"Dodaj artikl"</strong></li>
          <li>U formi vidjet ćete polja za svaku aktivnu valutu</li>
          <li>Unesite cijenu za svaku valutu</li>
        </ol>

        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>EUR (€)</th>
              <th>USD ($)</th>
              <th>GBP (£)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>2.50 €</td>
              <td>2.70 $</td>
              <td>2.20 £</td>
            </tr>
            <tr>
              <td>Cappuccino</td>
              <td>3.00 €</td>
              <td>3.25 $</td>
              <td>2.60 £</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Automatsko izračunavanje cijena</h3>
        <p>Sustav može automatski izračunati cijene za druge valute:</p>
        <ul>
          <li>Unesite cijenu u primarnoj valuti (npr. EUR)</li>
          <li>Kliknite <strong>"Izračunaj ostale valute"</strong></li>
          <li>Sustav koristi postavljeni tečaj za automatski izračun</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Automatski izračunate cijene možete ručno prilagoditi. Preporučujemo da cijene zaokružite na razumne iznose (npr. $2.99 umjesto $2.9847).
          </div>
        </div>

        <h3 class="mt-4">Odabir valute na blagajni</h3>
        <p>Prilikom izdavanja računa:</p>
        <ol>
          <li>Operator može odabrati valutu prije dodavanja artikala</li>
          <li>Ili odabrati valutu na kraju, prije plaćanja</li>
          <li>Sustav automatski prikazuje cijene u odabranoj valuti</li>
        </ol>

        <h3 class="mt-4">Tečajna lista</h3>
        <p>Redovno ažurirajte tečajeve:</p>
        <ol>
          <li>Idite na <strong>"Postavke" → "Firma" → "Valute"</strong></li>
          <li>Kliknite <i class="mdi mdi-pencil"></i> pored valute</li>
          <li>Unesite novi tečaj</li>
          <li>Kliknite <strong>"Spremi"</strong></li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Ako poslujete s turistima, dodajte najpopularnije valute (EUR, USD, GBP) i ažurirajte tečajeve tjedno.
          </div>
        </div>

        <h2 id="tips" class="mt-6">Česta pitanja</h2>
        <ul>
          <li><strong>Mogu li izdati račun u dvije valute?</strong> - Ne, svaki račun je u jednoj valuti</li>
          <li><strong>Kako se računaju povrati?</strong> - Povrati se daju u istoj valuti kao i plaćanje</li>
          <li><strong>Fiskalizira li se u svim valutama?</strong> - Da, ali s FIN-om komunicira u primarnoj valuti firme</li>
        </ul>
      `
    }
  ]
}
